export const mapPlanDetailsToFormValues = (planDetails: any) => {
    return {
      planId: planDetails?.id,
      name: planDetails?.name,
      cost: "",
      chargeCycle: planDetails?.chargeCycle,
      storyCreationLimit: planDetails?.storyCreationLimit,
      imageCredits: planDetails?.credits,
      additionalImageCredits: planDetails?.additionalAICredit?.credits,
      additionalImageCreditsCost: planDetails?.additionalAICredit?.price,
      maxBookPage: planDetails?.maxBookPage,
      additionalStoryCreationLimit: planDetails?.additionalAICredit?.storyCreationLimit,
      additionalStoryCreationCost: planDetails?.additionalAICredit?.storyCreationCost,
      modeCharacterGeneration: planDetails?.modeCharacterGeneration || "",
      modeIllustrationGeneration: planDetails?.modeIllustrationGeneration || "",
      maintenanceMode: planDetails?.maintenanceMode || false,
      showOnSubscription: planDetails?.showOnSubscription || false,
      trialDays: planDetails?.trialDays || 0,
      freePhysicalBookStatus: planDetails?.freePhysicalBookStatus ? planDetails?.freePhysicalBookStatus : false,
      freePhysicalBookQuantity: planDetails?.freePhysicalBookQuantity || 0,
      mics: planDetails?.mics || "",
    };
};
  

export const initialPlanData = {
  planId: null,
  name: "",
  cost: "",
  chargeCycle: "",
  storyCreationLimit: 0,
  imageCredits: "",
  additionalImageCredits: "",
  additionalImageCreditsCost: "",
  maxBookPage: "",
  additionalStoryCreationLimit: "",
  additionalStoryCreationCost: "",
  modeCharacterGeneration: "",
  modeIllustrationGeneration: "",
  maintenanceMode: false,
  showOnSubscription: false,
  trialDays: 0,
  freePhysicalBookStatus: false,
  freePhysicalBookQuantity: 1,
  mics: "",
}